import * as yup from 'yup';
export const createValidationSchema = () => {
  return yup.object({
    companyEmail: yup.string().nullable().email('common.enter_valid_email'),
  });
};
